import Admins from '../pages/administrators';
import Doctors from '../pages/doctors';
import Clinics from '../pages/clinics';
import Members from '../pages/members';
import Alerts from '../pages/alerts';
import Login from '../pages/login';
import { AppRoute } from '../types/appRoute';
import MemberPage from '../pages/members/MemberPage';
import CompleteProfile from '../pages/complete-profile';
import DeleteAccount from '../pages/delete-account';
import BodySystems from '../pages/medical-library';
import Nutritionist from '../pages/nutritionist';
import InuviFiles from '../pages/inuvi-files';
import PharmacySearch from '../pages/pharmacy-search';
import PrivacyPolicy from '../pages/privacy-policy';
import TermsCondition from '../pages/terms-conditions';
import Subscription from '../pages/subscription';
import CompleteSubscription from '../pages/complete-subscription';
import AppointmentsPage from '../pages/appointments';
import Account from '../pages/account';
import Chat from '../pages/chat';
import Confirmation from '../pages/confirmation';
import Plans from '../pages/plans';
import PlansCore from '../pages/plans-core';
import PreScanQuestions from '../pages/pre-scan-questions';
import PreScanQuestionnairePdf from '../pages/pre-scan-questionnaire-pdf';
import PlansPlus from '../pages/plans-plus';
import BloodOnlyCheckout from '../pages/blood-only-checkout';
import ScanOnly from '../pages/scan-only';
import ScanLanding from '../pages/scan';
import CompleteOnboarding from '../pages/complete-onboarding';
import ScanCheckout from '../pages/scan-checkout';
import BloodUploadTracker from '../pages/blood-upload-tracker';
import FailedPayments from '../pages/failed-payments';
import Scheduler from '../pages/scheduler/index';
import GlobalAuditLogs from '../pages/global-audit-logs';
import Teams from '../pages/teams';
import MarketingCms from '../pages/marketing-cms';
import ClinicalDashboard from '../pages/clinical-dashboard';
import Lp1 from '../pages/lp-1';
import Lp1PaymentSuccess from '../pages/lp-1/PaymentSuccess';
import AnnualScan from '../pages/annual-scan';
import AnnualScanPaymentSuccess from '../pages/annual-scan/PaymentSuccess';

export const mainRoutes: AppRoute[] = [
  {
    path: '/',
    element: <Admins />,
    meta: { title: 'administrators', showSidebar: true },
  },
  {
    path: '/doctors',
    element: <Doctors />,
    meta: { title: 'doctors', showSidebar: true },
  },
  {
    path: '/cv-dashboard',
    element: <ClinicalDashboard />,
    meta: { title: 'CV Dashboard', showSidebar: true },
  },
  {
    path: '/nutritionists',
    element: <Nutritionist />,
    meta: { title: 'nutritionists', showSidebar: true },
  },
  {
    path: '/clinics',
    element: <Clinics />,
    meta: { title: 'clinics', showSidebar: true },
  },
  {
    path: '/members',
    element: <Members />,
    meta: { title: 'members', showSidebar: true },
  },
  {
    path: '/alerts',
    element: <Alerts />,
    meta: { title: 'alerts', showSidebar: true },
  },
  {
    path: '/chat',
    element: <Chat />,
    meta: { title: 'chat', showSidebar: true },
  },

  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
    meta: { title: 'Privacy Policy', showSidebar: true },
  },
  {
    path: '/terms-conditions',
    element: <TermsCondition />,
    meta: { title: 'Terms and Conditions', showSidebar: true },
  },
  {
    path: '/body-systems',
    element: <BodySystems />,
    meta: { title: 'Medical Library', showSidebar: true },
  },
  
  {
    path: '/members/:id',
    element: <MemberPage />,
    meta: {
      title: 'User Details',
      showSidebar: false,
      isDynamicTitle: true,
    },
  },
   {
    path: '/inuvi-files',
    element: <InuviFiles />,
    meta: { title: 'Inuvi Files', showSidebar: true },
  },
   {
    path: '/appointments',
    element: <AppointmentsPage />,
    meta: { title: 'Global Appointment', showSidebar: true },
  },
  {
    path: '/blood-upload-tracker',
    element: <BloodUploadTracker />,
    meta: { title: 'Blood Upload Tracker', showSidebar: true },
  },
  {
    path: '/failed-payments',
    element: <FailedPayments />,
    meta: { title: 'Failed Payments', showSidebar: true },
  },
  {
    path: '/scheduler',
    element: <Scheduler />,
    meta: { title: 'Scheduler', showSidebar: true },
  },
  {
    path: '/audit-logs',
    element: <GlobalAuditLogs />,
    meta: { title: 'AI Logs', showSidebar: true },
  },
  {
    path: '/teams',
    element: <Teams />,
    meta: { title: 'Teams', showSidebar: true },
  },
  {
    path: '/marketing-cms',
    element: <MarketingCms />,
    meta: { title: 'Website CMS', showSidebar: true },
  },
];

export const authRoutes: AppRoute[] = [
  {
    path: 'login',
    element: <Login />,
  },
];
export const profileRoute: AppRoute[] = [
  {
    path: '/complete-profile',
    element: <CompleteProfile />,
  },
];
export const deleteAccountRoute: AppRoute[] = [
  {
    path: '/delete-account',
    element: <DeleteAccount />,
  },
];

export const pharmacyRoutes: AppRoute[] = [
  {
    path: '/book-test',
    element: <PharmacySearch />,
  },
];

export const subscriptionRoutes: AppRoute[] = [
  {
    path: '/subscription',
    element: <Subscription />,
  },
  {
    path: '/complete-subscription',
    element: <CompleteSubscription />,
  },
];

export const signupRoutes: AppRoute[] = [
  {
    path: 'today',
    element: <Account />,
  },
];

export const confirmationRoutes: AppRoute[] = [
  {
    path: '/confirmation',
    element: <Confirmation />,
  },
];

export const scanCheckoutRoutes: AppRoute[] = [
  {
    path: '',
    element: <ScanCheckout />,
  },
];
export const planRoutes: AppRoute[] = [
  {
    path: '',
    element: <Plans />,
  },
];

export const bloodOnlyCheckoutRoutes: AppRoute[] = [
  {
    path: '',
    element: <BloodOnlyCheckout />,
  },
];

export const planCoreRoutes: AppRoute[] = [
  {
    path: '',
    element: <PlansCore />,
  },
];

export const preScanQuestions: AppRoute[] = [
  {
    path: '',
    element: <PreScanQuestions />,
  },
];

export const preScanQuestionnairePdfRoutes: AppRoute[] = [
  {
    path: '',
    element: <PreScanQuestionnairePdf />,
  },
];

export const planPlusRoutes: AppRoute[] = [
  {
    path: '',
    element: <PlansPlus />,
  },
];
export const scanOnlyRoutes: AppRoute[] = [
  {
    path: '',
    element: <ScanOnly />,
    
  },
];

export const scanLandingRoutes: AppRoute[] = [
  {
    path: '',
    element: <ScanLanding />,
  },
];

export const completeOnboardingRoutes: AppRoute[] = [
  {
    path: '/complete-onboarding',
    element: <CompleteOnboarding />,
  },
];

export const lp1Routes: AppRoute[] = [
  {
    path: '',
    element: <Lp1 />,
  },
  {
    path: 'payment-successful',
    element: <Lp1PaymentSuccess />,
  },
];

export const annualScanRoutes: AppRoute[] = [
  {
    path: '',
    element: <AnnualScan />,
  },
  {
    path: 'payment-successful',
    element: <AnnualScanPaymentSuccess />,
  },
];